module.exports = __webpack_public_path__ + "img/9788936456115.92851a8f.jpg";